// store/modules/notifications/getters.js
export default {
  notification: (state) => state.notification,
};
